export default __webpack_public_path__ + "media/images/map/marker_service_green-d1f0c0f14ea5f362963a988bd8e76f59.png";